// src/hooks/use-breakpoint.ts
import { useWindowSize } from "react-use";
var breakpoints = {
  sm: 480,
  md: 960,
  lg: 1440
};
function useBreakpoint() {
  const bp = Object.entries(breakpoints).sort(
    ([, width1], [, width2]) => width1 - width2
  );
  const { width } = useWindowSize();
  for (const breakpoint of bp) {
    if (width < breakpoint[1]) {
      return breakpoint[0];
    }
    continue;
  }
  return "xl";
}

export {
  useBreakpoint
};
